
import style from './miniTaskCard.module.css';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';

export default function MiniTaskCard(props) {

    const [tasks, setTasks] = useState('')
    const [error, setError] = useState('');
    const { employeeId } = useParams();
    const apiurl = process.env.REACT_APP_SERVER_URL;

    useEffect(() => {
        fetch(`${apiurl}/employee/${employeeId}/tasks`)
            .then((res) => res.json())
            .then((data) => {
                setTasks(data.tasks)
            })
            .catch((err) => setError(err.message))
    }, [apiurl, employeeId])

    return (
        <>
            <div style={{ display: 'none' }}>
                {tasks && <p>{tasks}</p>}
                {error && <p>{error}</p>}
            </div>
            <div className={`${style.miniCard} `}>
                <div className="d-flex align-items-center p-3 shadow">

                    {/* Left Icon */}
                    <div
                        className="d-flex align-items-center justify-content-center me-3 "
                        style={{
                            width: "50px",
                            height: "50px",
                            backgroundColor: props.backgroundColor || "#f0f0f0",
                            color: props.color || "#000",
                        }}
                    >
                        {props.icon}
                    </div>
                    {/* Right Content */}
                    <div>
                        <div className={`${style.heading} fw-bold mb-2`}>{props.length}</div>
                        <div className={style.taskTitle}>{props.title}</div>
                    </div>

                </div>
            </div>

        </>
    )
}